export default "__VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__"